/**
 * List Schema of Sistema
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Sistema} from '@/model/resource/Sistema'

/* TODO: review generated schema */
export class ListSistemaSchema extends Schema {
  readonly name = 'ListSistema'

  readonly fieldSet: FieldSet<Sistema> = {
    idSistemaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
